<template>
  <multiselect
    :value="value"
    :options="options"
    label="LanguageName"
    track-by="ID"
    selectLabel
    selectedLabel
    deselectLabel
    :placeholder="placeholder"
    open-direction="bottom"
    class="dark lang-selector"
    @input="$emit('input', $event)"
    :disabled="disabled"
  >
    <template v-slot:option="props">
      <img
        v-if="props.option.CountryISOCode"
        :src="`/img/lang/${props.option.CountryISOCode.toLowerCase()}.png`"
        class="option__image"
      />
      <span class="option__title">{{ props.option[printField] }}</span>
    </template>
    <template v-slot:singleLabel="{option}">
      <div class="selected-option">
        <img
          v-if="option.CountryISOCode"
          :src="`/img/lang/${option.CountryISOCode.toLowerCase()}.png`"
          class="option__image"
        />
        <span class="option__title">{{ option[printField] }}</span>
      </div>
    </template>
  </multiselect>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  components: {
    multiselect: () => import('vue-multiselect'),
  },
  props: {
    placeholder: {
      type: String,
      default: () => String('Language'),
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
    },
    printField: {
      type: String,
      default: () => String('LanguageName'),
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
});
</script>

<style lang="scss" scoped>
  .lang-selector {
    width: 188px;
  }
  .selected-option {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
